import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"; // Import useSelector and useDispatch
import Button from "react-bootstrap/Button";
import "./cstyle.css";
import { useNavigate } from "react-router-dom";
import { setLanguage } from "../redux/languageSlice"; // Import language actions and selectors
import Sidebar from "../components/sidebar";
import { socket } from "../../src/socket";
import Swal from "sweetalert2";
import translations from "../locals/translation";
import { performVerification } from "../commonFunc/verification";
import { Menu } from "@mui/material";

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch(); // Get dispatch function

  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const t = (key) => {
    // Check if translations exist for the current language
    if (translations[language]) {
      // Access translation for the provided key
      const translation = translations[language][key];
      // Return translation if found, otherwise return the key itself
      return translation !== undefined ? translation : key;
    } else {
      // Return the key itself if translations for the current language are not available
      return key;
    }
  };

  const language = useSelector((state) => state.language.value);

  // Function to handle language change
  const changeLanguage = (lang) => {
    dispatch(setLanguage(lang)); // Dispatch action to update language
  };
  const lang2 = localStorage.getItem("lang");
  const [lang] = useState(lang2);

  const logout = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: t("Do you want to Logout?"),
        text: "",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: t("Cancel"),
        confirmButtonText: t("Logout"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          localStorage.clear();
          localStorage.setItem("lang", lang);
          socket.on("disconnect");
          navigate("/");
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      });
  };

  useEffect(() => {
    if (!performVerification()) {
      Swal.fire({ text: t("Login first"), icon: "warning" });
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [display, setDisplay] = useState(false);
  return (
    <>
      <div>
        <nav className="nav">
          <div
            className={`navbar-buton ${display ? "activestate" : ""}`}
            onClick={() => {
              setDisplay(!display);
            }}
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="24" cy="24" r="24" fill="#431117" />
              <rect
                x="11.0769"
                y="12.9231"
                width="25.8462"
                height="3.69231"
                fill="white"
              />
              <rect
                x="11.0769"
                y="22.1538"
                width="25.8462"
                height="3.69231"
                fill="white"
              />
              <rect
                x="11.0769"
                y="31.3846"
                width="25.8462"
                height="3.69231"
                fill="white"
              />
            </svg>
          </div>
          <div className="logo">
            <img
              src="./img/sideLogo.png"
              alt="logo"
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </div>
          <div className="button btn-box">
            <Button
              variant="success"
              className="buttons"
              style={{ background: "rgba(67, 17, 23, 1)", outline: "none" }}
              onClick={() => {
                logout();
              }}
            >
              {t("Logout")}
            </Button>{" "}
          </div>

          <div className="button language-box">
            {/* Language switcher */}
            <select
              value={language}
              onChange={(e) => changeLanguage(e.target.value)}
            >
              <option value="en" disabled={language === "en"}>
                EN
              </option>
              <option value="es" disabled={language === "es"}>
                ES
              </option>
            </select>

            <Menu
              sx={{ mt: "30px", width: "60%", height: "80%" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            ></Menu>
          </div>
        </nav>
      </div>
      <Sidebar visibility={display} />
    </>
  );
}

export default Header;
